import RightsScreen from "../../screens/RightsScreen";
import { connect } from "react-redux";
import { fetchRightsCategories } from "../actions/rightsActions";

const mapStateToProps = (state) => ({
  rights: state.rights.rights,
  subrights: state.rights.subrights,
  learnMoresNew: state.rights.learnMores,
  translationMap: state.rights.translationMap,
  isTranslationMapLoading: state.rights.isTranslationMapLoading,
});

const mapDispatchToProps = (dispatch) => ({
  fetchRights: () => dispatch(fetchRightsCategories()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RightsScreen);
